export const TOGGLE = "TOGGLE";

export const burguerMenu = () => ({
  type: TOGGLE,
});